<div class="home-container">
  <!-- Logo posicionado como en la imagen original -->
  <div class="home-logo-box">
    <img src="assets/img/logo.svg" alt="Cbb Store" class="home-logo-main" />
  </div>

  <!-- Tagline Central -->
  <div class="home-hero-text">
    <h1 class="hero-primary">
      <span class="text-light">Tenemos la </span>
      <strong>solución para tu proyecto.</strong>
    </h1>
    <h2 class="hero-secondary">
      <span class="text-light">Compra en </span>
      <strong>simples pasos. </strong>
      <span class="text-light">Despachamos </span>
      <strong>directo a tu obra.</strong>
    </h2>
  </div>

  <!-- Cards Grid -->
  <div class="home-grid">
    <div class="home-card" *ngFor="let panel of BUSINESS_PANELS">
      <h3 class="card-title">{{ panel.productLabel | titlecase }}</h3>

      <div class="card-image-container">
        <a [routerLink]="panel.route" class="card-image-link">
          <img
            *ngIf="panel.productLabel === 'hormigón'"
            src="assets/img/home/hormigon.png"
            alt="Hormigón"
            class="card-img card-img-clickable"
          />
          <img
            *ngIf="panel.productLabel === 'cemento'"
            src="assets/img/home/cemento.png"
            alt="Cemento"
            class="card-img card-img-clickable"
          />
        </a>
      </div>

      <p class="card-description" *ngIf="panel.productLabel === 'hormigón'">
        De pequeñas a grandes obras, pide<br />
        hormigón premezclado Cbb Ready Mix.
      </p>
      <p class="card-description" *ngIf="panel.productLabel === 'cemento'">
        Optimiza tus tiempos, asegura tu stock<br />
        y solicita cemento Cbb con despacho.
      </p>

      <a [routerLink]="panel.route" class="card-btn">COMPRA AQUÍ</a>
    </div>
  </div>
</div>
